const LayoutColors = {
  backgroundColor: "#063D8A",
  contrastColor:"#000000"
};

export default LayoutColors;

